module.exports = __webpack_public_path__ + "img/maisonier-upgrade.01b586f5.svg";